import React, { useState, useEffect } from 'react';

import TextInput from '../TextInput';

export default function BankAccountInput({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  link,
  tabindex,
  isVisible,
  mask,
  readOnly,
  postfix,
  disabled,
}) {
  const [bankAccountValue, setBankAccountValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setBankAccountValue(value);
  }, [value]);

  // Mask account number all digits except last 4 when focused
  useEffect(() => {
    if (isFocused) {
      setBankAccountValue(value);
    } else {
      setBankAccountValue(value?.replace(/.(?=.{4})/g, '* '));
    }
  }, [isFocused, value]);

  return (
    <TextInput
      label={label}
      type={type}
      name={name}
      value={bankAccountValue}
      onChange={onChange}
      onBlur={(event) => {
        setIsFocused(false);
        onBlur(event);
      }}
      onFocus={() => setIsFocused(true)}
      error={error}
      touched={touched}
      link={link}
      tabindex={tabindex}
      isVisible={isVisible}
      mask={mask}
      readOnly={readOnly}
      postfix={postfix}
      disabled={disabled}
    />
  );
}
